<template>
    <b-card-code title="Router List" class="router-list-card">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-2 router-list-header">
            <div>
                <h4 class="mb-0">Routers</h4>
                <small class="text-muted">Monitor connectivity and routing health</small>
            </div>
            <div class="d-flex align-items-center">
                <b-button
                    variant="primary"
                    :to="{ name: 'isp-router-create'}"
                >
                    <feather-icon icon="PlusIcon" size="16" class="mr-50" />
                    Add Router
                </b-button>
                <b-button
                    variant="outline-secondary"
                    class="ml-1"
                    @click="refreshRouters"
                >
                    <feather-icon icon="RefreshCwIcon" size="16" class="mr-50" />
                    Refresh
                </b-button>
            </div>
        </div>
        <div class="row mb-2">
            <div
                v-for="item in statisticsItems"
                :key="item.label"
                class="col-xl-3 col-sm-6 mb-1"
            >
                <div class="d-flex align-items-center p-1 router-kpi-card">
                    <b-avatar size="42" :variant="item.color" class="mr-1">
                        <feather-icon :icon="item.icon" size="18" />
                    </b-avatar>
                    <div>
                        <div class="font-weight-bolder">{{ item.value }}</div>
                        <small class="text-muted">{{ item.label }}</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="border rounded p-1 mb-2 router-filter-panel">
            <div class="row">
                <div class="col-12 col-md-3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filters.status" :options="statusOptions" />
                    </b-form-group>
                </div>
                <div class="col-12 col-md-3">
                    <b-form-group label="Router Name">
                        <b-form-input
                            v-model="filters.name"
                            placeholder="Search name"
                            type="text"
                        />
                    </b-form-group>
                </div>
                <div class="col-12 col-md-3">
                    <b-form-group label="IP / Port">
                        <b-form-input
                            v-model="filters.ip"
                            placeholder="192.168.0.1 or 8728"
                            type="text"
                        />
                    </b-form-group>
                </div>
                <div class="col-12 col-md-3">
                    <b-form-group label="Username">
                        <b-form-input
                            v-model="filters.username"
                            placeholder="Search username"
                            type="text"
                        />
                    </b-form-group>
                </div>
            </div>
            <div v-if="activeFilterChips.length" class="d-flex flex-wrap align-items-center">
                <small class="text-muted mr-1">Active filters:</small>
                <b-badge
                    v-for="chip in activeFilterChips"
                    :key="chip.key"
                    variant="light-secondary"
                    class="mr-50 mb-50 cursor-pointer"
                    @click="clearFilter(chip.key)"
                >
                    {{ chip.label }} ×
                </b-badge>
                <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="ml-50"
                    @click="clearAllFilters"
                >
                    Clear
                </b-button>
            </div>
        </div>
        <!-- table -->
        <vue-good-table
            v-if="rows.length > 0"
            :columns="columns"
            :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
            :rows="filteredRows"
            :rtl="direction"
            :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        >
            <template
                slot="table-row"
                slot-scope="props"
            >
            <div
          v-if="props.column.field === 'not_billing'"
          class="text-nowrap"
        >
          <b-dropdown
            size="sm"
            variant="outline-primary"
            class="router-actions-dropdown"
          >
            <template v-slot:button-content>
              Lists
            </template>
            <b-dropdown-item
              :to="{
                name: 'not-in-billing-users',
                params: { routerId: props.row.id },
              }"
            >
              Not in Billing
            </b-dropdown-item>
            <b-dropdown-item
              :to="{
                name: 'not-in-router-users',
                params: { routerId: props.row.id },
              }"
            >
              Not in Router
            </b-dropdown-item>
            <b-dropdown-item
              :to="{
                name: 'offline-users',
                params: { routerId: props.row.id },
              }"
            >
              Offline Users
            </b-dropdown-item>
          </b-dropdown>
        </div>
            <div
                v-if="props.column.field === 'indicator'"
                class="text-nowrap text-center"
            >
              <span v-if="props.row.is_connected" class="led green blink"></span>
              <span v-else class="led red blink"></span>
            </div>
                <!-- Column: Name -->
                <div
                    v-if="props.column.field === 'router_name'"
                    class="text-nowrap"
                >
                    <div class="d-flex align-items-center">
                        <div class="mr-1">
                            <span v-if="props.row.is_connected" class="led green blink led-sm"></span>
                            <span v-else class="led red blink led-sm"></span>
                        </div>
                        <div>
                            <div class="font-weight-bolder text-dark">{{ props.row.router_name }}</div>
                            <small class="text-muted">{{ props.row.username }}</small>
                        </div>
                    </div>
                </div>
                <div
                    v-else-if="props.column.field === 'ip_port'"
                    class="text-nowrap"
                >
                    <div class="font-weight-bolder text-dark">{{ props.row.ip_address }}</div>
                    <small class="text-muted">Port: {{ props.row.api_port }}</small>
                </div>

                <!-- Column: Status -->
                <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusBadgeVariant(props.row)">
            {{ props.row.status }}
          </b-badge>
        </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
                no-caret
                toggle-class="text-decoration-none"
                variant="link"
            >
              <template v-slot:button-content>
                <feather-icon
                    class="text-body align-middle mr-25"
                    icon="MoreVerticalIcon"
                    size="16"
                />
              </template>
              <b-dropdown-item :to="'/isp/router-edit/'+ props.row.id">
                <feather-icon
                    class="mr-50"
                    icon="Edit2Icon"
                />
                   <span>Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

                <!-- Column: Common -->
                <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
            </template>

            <!-- pagination -->
            <template
                slot="pagination-bottom"
                slot-scope="props"
            >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
                        <b-form-select
                            v-model="pageLength"
                            :options="['20','50','100']"
                            class="mx-1"
                            @input="(value)=>props.perPageChanged({currentPerPage:value})"
                        />
                        <span class="text-nowrap "> of {{ props.total }} entries </span>
                    </div>
                    <div>
                        <b-pagination
                            :per-page="pageLength"
                            :total-rows="props.total"
                            :value="1"
                            align="right"
                            class="mt-1 mb-0"
                            first-number
                            last-number
                            next-class="next-item"
                            prev-class="prev-item"
                            @input="(value)=>props.pageChanged({currentPage:value})"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
      <div v-else-if="isLoading" class="router-skeleton">
        <div class="router-loading-text">Loading router connections...</div>
        <div
          v-for="n in 6"
          :key="`router-skeleton-${n}`"
          class="router-skeleton-row"
        >
          <div class="router-skeleton-dot"></div>
          <div class="router-skeleton-block router-skeleton-block--lg"></div>
          <div class="router-skeleton-block router-skeleton-block--md"></div>
          <div class="router-skeleton-block router-skeleton-block--sm"></div>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center align-items-center">
        <span class="text-center mr-3" style="font-size: 26px">
          No routers found for this ISP.
        </span>
      </div>
    </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BLink, BButton,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store'
import {ROUTER_LIST} from '@core/services/api.js'
import $ from "jquery";

export default {
    components: {
        BLink,
        BCardCode,
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BButton,
    },
    data() {
        return {
            pageLength: 20,
            dir: false,
            columns: [
                {
                    label: '',
                    field: 'indicator',
                },
                {
                    label: 'Router Name',
                    field: 'router_name',
                    // filterOptions: {
                    //     enabled: true,
                    //     placeholder: 'Search Route Name',
                    // },
                },
                {
                    label: 'IP / Port',
                    field: 'ip_port',
                },
                {
                    label: 'List',
                    field: 'not_billing',
                },
                {
                    label: 'User Name',
                    field: 'username',
                    // filterOptions: {
                    //     enabled: true,
                    //     placeholder: 'Search UserName',
                    // },
                },
                {
                    label: 'Status',
                    field: 'status',
                    // filterOptions: {
                    //     enabled: true,
                    //     placeholder: 'Search Status',
                    // },
                },
                {
                    label: 'Action',
                    field: 'action',
                },
            ],
            rows: [],
            searchTerm: '',
            filters: {
                status: 'All',
                name: '',
                ip: '',
                username: '',
            },
            isLoading: false,
            isp_id:null,
        }
    },
    computed: {
        statusOptions() {
            return [
                { value: 'All', text: 'All Status' },
                { value: 'Active', text: 'Active' },
                { value: 'Inactive', text: 'Inactive' },
            ]
        },
        statisticsItems() {
            const total = this.rows.length
            const active = this.rows.filter(row => row.status === 'Active').length
            const inactive = total - active
            const online = this.rows.filter(row => row.is_connected).length
            const offline = Math.max(active - online, 0)

            return [
                {
                    label: 'Total Routers',
                    value: total,
                    icon: 'ServerIcon',
                    color: 'light-primary',
                },
                {
                    label: 'Online',
                    value: online,
                    icon: 'CheckCircleIcon',
                    color: 'light-success',
                },
                {
                    label: 'Offline',
                    value: offline,
                    icon: 'AlertTriangleIcon',
                    color: 'light-warning',
                },
                {
                    label: 'Inactive',
                    value: inactive,
                    icon: 'XCircleIcon',
                    color: 'light-secondary',
                },
            ]
        },
        activeFilterChips() {
            const chips = []
            if (this.filters.status && this.filters.status !== 'All') {
                chips.push({ key: 'status', label: `Status: ${this.filters.status}` })
            }
            if (this.filters.name) {
                chips.push({ key: 'name', label: `Name: ${this.filters.name}` })
            }
            if (this.filters.ip) {
                chips.push({ key: 'ip', label: `IP/Port: ${this.filters.ip}` })
            }
            if (this.filters.username) {
                chips.push({ key: 'username', label: `User: ${this.filters.username}` })
            }
            return chips
        },
        filteredRows() {
            const nameTerm = this.filters.name.toLowerCase()
            const ipTerm = this.filters.ip.toLowerCase()
            const userTerm = this.filters.username.toLowerCase()
            const statusFilter = this.filters.status

            return this.rows.filter(row => {
                const name = (row.router_name || '').toString().toLowerCase()
                const ip = (row.ip_address || '').toString().toLowerCase()
                const port = row.api_port !== undefined && row.api_port !== null ? String(row.api_port) : ''
                const user = (row.username || '').toString().toLowerCase()
                const ipPort = `${ip}:${port}`.toLowerCase()

                const matchesStatus = statusFilter === 'All' || row.status === statusFilter
                const matchesName = !nameTerm || name.includes(nameTerm)
                const matchesIp = !ipTerm || ip.includes(ipTerm) || port.includes(ipTerm) || ipPort.includes(ipTerm)
                const matchesUser = !userTerm || user.includes(userTerm)

                return matchesStatus && matchesName && matchesIp && matchesUser
            })
        },
        statusVariant() {
            const statusColor = {
                /* eslint-disable key-spacing */
                Current: 'light-primary',
                Professional: 'light-success',
                Rejected: 'light-danger',
                Resigned: 'light-warning',
                Applied: 'light-info',
                /* eslint-enable key-spacing */
            }

            return status => statusColor[status]
        },
        statusBadgeVariant() {
            return row => {
                if (row.status === 'Inactive') return 'light-secondary'
                return row.is_connected ? 'light-success' : 'light-danger'
            }
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    mounted() {
        this.isp_id = $("#ispListId option:selected").val();
        this.routerList(this.isp_id);
    let instance = this;
    $("#ispListId").change(function () {
         this.isp_id = $(this).children("option:selected").val();
         instance.routerList(this.isp_id);
    });
    },
    methods:{
        refreshRouters() {
            this.routerList(this.isp_id)
        },
        sortRowsByName(items) {
            return items.slice().sort((a, b) => {
                const nameA = (a.router_name || '').toString()
                const nameB = (b.router_name || '').toString()
                return nameA.localeCompare(nameB, undefined, { sensitivity: 'base', numeric: true })
            })
        },
        clearFilter(key) {
            if (key === 'status') {
                this.filters.status = 'All'
                return
            }
            if (this.filters[key] !== undefined) {
                this.filters[key] = ''
            }
        },
        clearAllFilters() {
            this.filters = {
                status: 'All',
                name: '',
                ip: '',
                username: '',
            }
        },
        routerList(ispId){ 
            this.isLoading = true
            this.$http.get(process.env.VUE_APP_BASEURL + ROUTER_LIST + "?isp_id="+ispId)
            .then(res => {
                const rows = res.data.data || []
                this.rows = this.sortRowsByName(rows)
            })
            .catch(() => {
                this.rows = []
            })
            .finally(() => {
                this.isLoading = false
            })
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
// Inspired by: https://github.com/aus/led.css
.router-list-card {
  .router-list-header {
    padding-bottom: 0.75rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .router-kpi-card {
    background: #f8fafc;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 0.5rem;
  }

  .router-filter-panel {
    background: #fbfbfc;
    border-color: #e6e8eb;
  }

  .router-skeleton {
    display: grid;
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .router-loading-text {
    font-weight: 600;
    font-size: 0.95rem;
    color: #59606b;
    letter-spacing: 0.02em;
    white-space: nowrap;
    overflow: hidden;
    border-right: 2px solid #9aa4b2;
    width: 0;
    max-width: 320px;
    animation: router-typing 2.6s steps(30, end) infinite, router-caret 0.8s step-end infinite;
  }

  .router-skeleton-row {
    display: grid;
    grid-template-columns: 16px minmax(120px, 1.2fr) minmax(120px, 1fr) minmax(80px, 0.6fr);
    gap: 0.75rem;
    align-items: center;
  }

  .router-skeleton-dot {
    width: 12px;
    height: 12px;
    border-radius: 999px;
    background: #e6e8eb;
  }

  .router-skeleton-block {
    height: 12px;
    border-radius: 999px;
    background: linear-gradient(90deg, #eceff3 0%, #f7f8fa 50%, #eceff3 100%);
    background-size: 200% 100%;
    animation: router-skeleton 1.4s ease-in-out infinite;
  }

  .router-skeleton-block--lg {
    height: 14px;
  }

  .router-skeleton-block--md {
    height: 12px;
  }

  .router-skeleton-block--sm {
    height: 10px;
    max-width: 120px;
  }
}

@keyframes router-skeleton {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes router-typing {
  0% {
    width: 0;
  }
  40% {
    width: 260px;
  }
  80% {
    width: 260px;
  }
  100% {
    width: 0;
  }
}

@keyframes router-caret {
  0%, 100% {
    border-color: transparent;
  }
  50% {
    border-color: #9aa4b2;
  }
}
@mixin ledColor($primaryColor, $secondaryColor) {
  background-color: $primaryColor;
}

@mixin blackLed($dimmedColor) {
  @include ledColor($dimmedColor, $dimmedColor);
}

@mixin led($name, $primaryColor, $secondaryColor, $dimmedColor, $blinkDuration) {
  &.#{$name} {
    @keyframes blink-#{$name} {
      from {
        @include blackLed($dimmedColor);
      }
      25% {
        @include blackLed($dimmedColor);
      }
      30% {
        @include ledColor($primaryColor, $secondaryColor);
      }
      75% {
        @include ledColor($primaryColor, $secondaryColor);
      }
      80% {
        @include blackLed($dimmedColor);
      }
      to {
        @include blackLed($dimmedColor);
      }
    }

    @include ledColor($primaryColor, $secondaryColor);

    &.blink {
      animation: blink-#{$name} $blinkDuration infinite;
    }
  }
}

.led {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.25);

  &.pulse {
    animation: pulse 4s infinite;
  }

  @include led('red', #f00, #600, #ac1f1f, 2.5s);   // Red LED with dimmed red color for blackLed
  @include led('green', #61b400, #060, #c9d3c0, 0.25s); // Green LED with dimmed green color for blackLed
}

.led-sm {
  width: 12px;
  height: 12px;
}

.router-actions-dropdown .dropdown-toggle {
  padding: 0.25rem 0.6rem;
}

</style>
<style>
/* HTML: <div class="loader"></div> */
.loader {
  width: 15px;
  height: 15px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
}
@keyframes l5 {
  0%  {box-shadow: 20px 0 #000, -20px 0 #0002;background: #000 }
  33% {box-shadow: 20px 0 #000, -20px 0 #0002;background: #0002}
  66% {box-shadow: 20px 0 #0002,-20px 0 #000; background: #0002}
  100%{box-shadow: 20px 0 #0002,-20px 0 #000; background: #000 }
}
</style>
